import React from "react"
import Icon from "../../../Icon"
import {WideViewIconContainer, NarrowViewIconContainer, Container, BrandIconContainerWrapper} from "./component"
import {removeDeptFromSessionStorage} from "../../../../utils/removeDeptFromSessionStorage"

export type BrandProps = {
    narrowModeIcon: string
    wideModeIcon: string
    tooltip: string
    url: string
    accessibilityText: string
}

export const Brand = ({accessibilityText, tooltip, url, narrowModeIcon, wideModeIcon}: BrandProps) => {
    const clickHandler = () => {
        removeDeptFromSessionStorage()
    }
    return (
        <Container className="header-adaptive-brand" data-testid="header-adaptive-brand" onClick={clickHandler}>
            <BrandIconContainerWrapper aria-label={accessibilityText} title={tooltip} href={url}>
                <NarrowViewIconContainer>
                    <Icon src={narrowModeIcon} alt={accessibilityText} />
                </NarrowViewIconContainer>
                <WideViewIconContainer>
                    <Icon src={wideModeIcon} alt={accessibilityText} />
                </WideViewIconContainer>
            </BrandIconContainerWrapper>
        </Container>
    )
}

export default Brand
